module.exports = __webpack_public_path__ + "img/robot_bg.30c30d67.svg";